// removed by extract-text-webpack-plugin
module.exports = {"shopAtContainer":"shopAtContainer__3BXHQ","shopAtHeading":"shopAtHeading__26ZWw","merchantsContainer":"merchantsContainer__1ao_t","lenderMerchantListDiv":"lenderMerchantListDiv__21zkD"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVC/merchants/style.css
// module id = h36M
// module chunks = 444